module.exports = __webpack_public_path__ + "static/media/driverPaymentsGradient.8c119328.svg";